import { useEffect } from 'react';

import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useAppDispatcher, useAppSelector } from 'src/redux/store';
import { getLoanAgreementById } from 'src/redux/slices/loan-agreement';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LoadingScreen } from 'src/components/loading-screen';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import LoanAgreementEditForm from '../loan-agreement-edit-form';

type Props = {
  id: string;
};

export default function LoanAgreementEditView({ id }: Props) {
  const { status, data, error } = useAppSelector((state) => state.loanAgreement.agreement);

  const settings = useSettingsContext();

  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getLoanAgreementById({ id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle' || (data && data._id !== id)) {
    return <LoadingScreen />;
  }

  if (status === 'failure' || !data) {
    return <ErrorContent filled title="Failed to load loan agreement" description={error} />;
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Edit Loan Agreement"
        links={[
          { name: 'Loans', href: paths.dashboard.loans.root(data.status) },
          { name: 'Details', href: paths.dashboard.loans.view(id) },
          { name: 'Edit' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <LoanAgreementEditForm key={data.updatedAt} agreement={data} />
    </Container>
  );
}
